export default __webpack_public_path__ + "static/media/handprint-34-35-page.72c0c0f0.png";